import { MNElement } from '../../../../common/elements/elementModelTypes';
import globalLogger from '../../../logger';

const logger = globalLogger.createChannel('getElementImageBlob');

export const getImageBlobFromDomElement = async (event: Event, element: MNElement): Promise<Blob | null> => {
    try {
        const target = event.target as HTMLElement;
        const imgElement = target.tagName === 'IMG' ? (target as HTMLImageElement) : target.querySelector('img');

        if (!imgElement) throw new Error('No image element found');

        const canvas = document.createElement('canvas');
        canvas.width = imgElement.naturalWidth || imgElement.width;
        canvas.height = imgElement.naturalHeight || imgElement.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('No 2d context');

        ctx.drawImage(imgElement, 0, 0);

        const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob((b) => resolve(b)));
        if (!blob) throw new Error('toBlob returned null');

        return blob;
    } catch (error) {
        logger.error('Failed to copy image data:', error);
        return null;
    }
};
